module.exports = __webpack_public_path__ + "static/media/create-story.0545a10d.png";